var map = {
	"./agro.png": 24537,
	"./background.png": 39528,
	"./bg image lady.png": 27936,
	"./bg-image lady.jpeg": 57718,
	"./bg-image.png": 95917,
	"./fonts/NotoSans-Bold.ttf": 84964,
	"./fonts/NotoSans-Bold.woff": 82036,
	"./fonts/NotoSans-Light.ttf": 47243,
	"./fonts/NotoSans-Light.woff": 91657,
	"./fonts/NotoSans-Medium.ttf": 74956,
	"./fonts/NotoSans-Medium.woff": 49372,
	"./fonts/NotoSans-Regular.ttf": 15819,
	"./fonts/NotoSans-Regular.woff": 9993,
	"./fonts/NotoSans-SemiBold.ttf": 15482,
	"./fonts/NotoSans-SemiBold.woff": 42314,
	"./green-leaves-white-background.png": 87505,
	"./green-leaves-white-background@2x.png": 31091,
	"./header.png": 43871,
	"./images/earning.svg": 35767,
	"./leaves.png": 91508,
	"./login_image_muranga2.png": 1969,
	"./logo.png": 33153,
	"./muranga_header.png": 17575,
	"./nhif@2x.png": 11457,
	"./school.png": 38516,
	"./shop_2x.png": 7719,
	"./spash": 6766,
	"./spash.json": 6766,
	"./success-icon.svg": 67011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;